module.exports = __webpack_public_path__ + "assets/img/37_1482_big.cfc1304b.jpg";